import { inject, Injectable } from '@angular/core';
import { catchError, concatMap, filter, from, Observable, of, switchMap, tap, throwError } from "rxjs";
import { ToastService } from "@core/services/toast.service";
import { BaseIndexedDbService } from "@core/storage/indexedDb/_database.service";

@Injectable({
  providedIn: 'root',
})
export abstract class BaseSynchronizeService<T> {
  protected abstract database: BaseIndexedDbService<T>;
  protected abstract apiFunction: (data: T) => Observable<object>;

  #toast = inject(ToastService);

  #sync(data: {id: number, data: T, synced: number, finalized: number}): Observable<unknown> {
    return this.apiFunction(data.data).pipe(
      tap(() => this.database.updateItem({
        id: data.id,
        data: data.data,
        synced: 1,
        finalized: 1
      }).then(() => {
        this.#toast.message('Adat feltöltése sikeresen megtörtént!', {type: 'success'});
      })),
      catchError(error => {
        console.error(`❌ Sync failed for ${data.id}`, error);
        return throwError(error);
      })
    );
  }

  public synchronizeById(id: number) {
    return from(this.database.getItem(id)).pipe(
      switchMap(data => this.#sync(data))
    );
  }

  public synchronize() {
    return from(this.database.getUnsyncedItems()).pipe(
      filter(items => items.length > 0),
      switchMap(items => from(items)),
      concatMap(item =>
        this.#sync(item).pipe(catchError(() => of(null))) // ilyenkor nem dobunk error-t
      ),
    );
  }
}
